import {
  FETCH_DRIVER_WALLETS_REQUEST,
  FETCH_DRIVER_WALLETS_SUCCESS,
  FETCH_DRIVER_WALLETS_FAILURE,
  ADMIN_TOP_UP_WALLET_REQUEST,
  ADMIN_TOP_UP_WALLET_SUCCESS,
  ADMIN_TOP_UP_WALLET_FAILURE,
} from "./types";

import {
  fetchDriverWallets,
  adminTopUpWallet,
} from "../../services/driverWalletService";

/* Fetch Wallets */

export const fetchDriverWalletsRequest = () => ({
  type: FETCH_DRIVER_WALLETS_REQUEST,
});

export const fetchDriverWalletsSuccess = (
  wallets
) => ({
  type: FETCH_DRIVER_WALLETS_SUCCESS,
  payload: wallets,
});

export const fetchDriverWalletsFailure = (
  error
) => ({
  type: FETCH_DRIVER_WALLETS_FAILURE,
  payload: error,
});

export const fetchDriverWalletsAction =
  () => async (dispatch) => {
    dispatch(fetchDriverWalletsRequest());

    try {
      const response =
        await fetchDriverWallets();

      if (response.success) {
        dispatch(
          fetchDriverWalletsSuccess(
            response.data
          )
        );

        return response;
      }

      dispatch(
        fetchDriverWalletsFailure(
          response.error
        )
      );

      return response;
    } catch (error) {
      const err =
        error.message ||
        "Failed to fetch driver wallets.";

      dispatch(
        fetchDriverWalletsFailure(err)
      );

      return {
        success: false,
        error: err,
      };
    }
  };

/* Admin Top-up */

export const adminTopUpWalletRequest = () => ({
  type: ADMIN_TOP_UP_WALLET_REQUEST,
});

export const adminTopUpWalletSuccess = (
  wallet
) => ({
  type: ADMIN_TOP_UP_WALLET_SUCCESS,
  payload: wallet,
});

export const adminTopUpWalletFailure = (
  error
) => ({
  type: ADMIN_TOP_UP_WALLET_FAILURE,
  payload: error,
});

export const adminTopUpWalletAction =
  (driverId, amount) =>
  async (dispatch) => {
    dispatch(adminTopUpWalletRequest());

    try {
      const response =
        await adminTopUpWallet(
          driverId,
          amount
        );

      if (response.success) {
        dispatch(
          adminTopUpWalletSuccess(
            response.data
          )
        );

        return response;
      }

      dispatch(
        adminTopUpWalletFailure(
          response.error
        )
      );

      return response;
    } catch (error) {
      const err =
        error.message ||
        "Failed to top up wallet.";

      dispatch(
        adminTopUpWalletFailure(err)
      );

      return {
        success: false,
        error: err,
      };
    }
  };